import { IUser } from "../modules/user/model/user";

export const getCurrentUser = (): Partial<IUser> => {
  try {
    const storedUser =
      localStorage.getItem("current_user") ||
      sessionStorage.getItem("current_user");
    if (storedUser) {
      return JSON.parse(storedUser) as Partial<IUser>;
    }
  } catch (error) {
    console.error("Failed to parse current_user from storage:", error);
  }
  return {};
};
